<template>
  <b-card>
    <base-overlay :loading="fetching">
      <b-table
        striped
        :items="admins"
        :fields="tableColumns"
        show-empty
        empty-text="No linked admins"
      />
    </base-overlay>
  </b-card>

</template>

<script>
import { ref } from '@vue/composition-api'
import { BTable, BCard } from 'bootstrap-vue'
import formatDate from '@/utils/date-format'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import BaseOverlay from '@/UI/BaseOverlay.vue'

export default {
  components: {
    BTable,
    BaseOverlay,
    BCard,
  },
  setup(props, ctx) {
    const businessId = ctx.root.$route.params.id
    const branches = ref([])
    const concatBranches = branchesPar => branches.value.reduce((prev, curr) => {
      if (branchesPar.includes(curr.id)) {
        return prev ? `${prev}, ${curr.name.en}` : `${curr.name.en}`
      } return `${prev}`
    }, '')

    const tableColumns = [
      {
        key: 'name',
      },
      {
        label: 'Phone Number',
        key: 'phoneNumber',
      },
      {
        key: 'email',
      },
      {
        key: 'role',
        formatter: val => val?.name,
      },
      {
        key: 'branches',

        formatter: value => {
          if (value) {
            if (value?.length === branches.value.length) {
              return 'All'
            }
            return concatBranches(value)
          }
          return 'All'
        },
      },
      {
        key: 'state',
        formatter: val => snakeCaseToCamelCase(val),
      },
      {
        label: 'Created At',
        key: 'createdAt',
        formatter: val => formatDate(val),
      },
    ]
    const admins = ref([])
    const fetching = ref(false)
    const fetch = async () => {
      fetching.value = true
      const result = await ctx.root.$store.dispatch('business/getBusinessBranch', businessId)
      const { data: branchesTemp } = result.data.data
      const res = await ctx.root.$store.dispatch('business/getBusinessAdmins', businessId)
      const { data } = res.data
      branches.value = branchesTemp
      admins.value = data
      fetching.value = false
      console.log(res, 'res')
    }
    fetch()
    return {
      fetching,
      tableColumns,
      admins,
      fetch,
    }
  },
}
</script>
